export default __webpack_public_path__ + "static/media/blood2.02ac4fae.png";